// base_search 1 

import SearchFilterSection from "./search_filter_section"

const BaseSearch1 = ({
    keywordPlaceholder = "關鍵字",
    defaultKeyword,
    conditionOptions = { 類別: ["通知信", "簡報"], 狀態: ["草稿", "已發佈"] },
    defaultConditions,
    advancedFields = [],
    defaultAdvancedValues,
    searchButtonText = '查詢',
    showConditionFilter = true,
    showAdvancedButton = true,
    onSearch = () => { },
    onKeywordChange = () => { },

}) => {
    return (<SearchFilterSection
        keywordPlaceholder={keywordPlaceholder}
        defaultKeyword={defaultKeyword}
        conditionOptions={conditionOptions}
        defaultConditions={defaultConditions}
        advancedFields={advancedFields}
        defaultAdvancedValues={defaultAdvancedValues}
        searchButtonText={searchButtonText}
        showConditionFilter={showConditionFilter}
        showAdvancedButton={showAdvancedButton}
        onSearch={onSearch}
        onKeywordChange={onKeywordChange}
    />)
}
export default BaseSearch1
